import { useState } from "react";
import { useParams } from "react-router-dom";

import { QuestionnaireStatus, TQuestionnairePayload } from "types";
import Modal from "ui/overlays/Modal";

import { DynamicQuestionnaire, QCForm, QCPreviewLayout, QuestionnaireCreatorLayout } from "./components";
import { usePostQuestionnaireMutation } from "./hooks";
import { QCPreviewValues } from "./questionnaire.types";
import { questionnaireRequestDataInitialValues } from "./questionnaire.utils";

export const QuestionnaireCreator = () => {
  const { mutate: onQuestionnaireSave, isLoading } = usePostQuestionnaireMutation();

  const { id } = useParams() as { id: string };

  const [previewData, setPreviewData] = useState<QCPreviewValues | undefined>();
  const [submitData, setSubmitData] = useState<TQuestionnairePayload | undefined>();

  const onPreviewOpen = (previewData: QCPreviewValues, data: TQuestionnairePayload) => {
    setPreviewData(previewData);
    setSubmitData(data);
  };

  const onPreviewClose = () => {
    setPreviewData(undefined);
    setSubmitData(undefined);
  };

  const onSave = (payload: TQuestionnairePayload) =>
    onQuestionnaireSave({ payload: { ...payload, status: QuestionnaireStatus.ACTIVE }, apiArgs: { accountId: id } });

  return (
    <QuestionnaireCreatorLayout>
      <QCForm onSubmit={onSave} onPreview={onPreviewOpen} isLoading={isLoading} />
      <Modal
        opened={!!previewData}
        handleClose={onPreviewClose}
        modalProps={{ fullScreen: true, transition: "fade", transitionTimingFunction: "ease", transitionDuration: 100 }}
      >
        {previewData && submitData && (
          <QCPreviewLayout
            title={previewData.title}
            description={previewData.description}
            onClickReturn={onPreviewClose}
            onSave={() => onSave(submitData)}
            isLoading={isLoading}
          >
            <DynamicQuestionnaire
              questionnaireData={{
                ...previewData,
                status: QuestionnaireStatus.DRAFT,
                accountId: id,
                id: ""
              }}
              questionnaireRequestData={questionnaireRequestDataInitialValues}
              submitEnabled={false}
              readOnly
              approveEnabled={false}
            />
          </QCPreviewLayout>
        )}
      </Modal>
    </QuestionnaireCreatorLayout>
  );
};
